import {
  getAudioVolume,
  adjustAudioVolume,
  resizeCaptionSize,
  getNumericCssVarsValues,
  adjustFontSizePercentage
} from '../../mixins/PlayerHelper';

export default {
  togglePlaySound({ commit, state }, audioObj = {}) {
    if (state.soundPlaying) audioObj.pause();
    else audioObj.play();
    commit('playPauseSound', !state.soundPlaying);
  },
  stopSound({ commit }, audioObj = {}) {
    audioObj.stop();
    commit('playPauseSound', false);
    commit('stopSound', true);
  },
  toggleMute({ commit, state }, audioObj = {}) {
    audioObj.mute(!state.soundMuted);
    commit('muteSound', !state.soundMuted);
  },
  toggleCaption({ commit, state }) {
    commit('setShowCaption', !state.showCaption);
  },
  toggleAnimations({ commit, state }) {
    commit('setAnimationsMode', !state.animationsOn);
    const { currentTweenIndex, onGoingAnimation } = state;

    if (state.animationsOn) {
      onGoingAnimation && onGoingAnimation.play();
    } else {
      onGoingAnimation && onGoingAnimation.addPause(2.1 * currentTweenIndex);
    }
  },
  setVolume({ commit }, { audioObj = {}, step = 0.1 }) {
    adjustAudioVolume(audioObj, step);
    const newVolume = getAudioVolume(audioObj);
    commit('setSoundVolume', newVolume);
  },
  resizeCaptionFontSize({ commit, state }, { captionElement, increment }) {
    // If captionElement is present, update its style
    let newFontSize;
    if (captionElement) {
      resizeCaptionSize(captionElement, increment);
      newFontSize = getNumericCssVarsValues(captionElement);
    } else {
      // If not present, calculate new font size from state
      const currentSize = state.captionSize || 18;
      newFontSize = Math.max(18, Math.min(36, currentSize + increment));
    }
    commit('setCaptionFontSize', newFontSize);
  },
  setFontSizePercentage({ commit, state }, increment) {
    const percentage = adjustFontSizePercentage(state.captionSizePercentage, increment);
    commit('setCaptionFontSizePercentage', percentage);
  }
};
